export default __webpack_public_path__ + "static/media/icon_format_pdf.61e9ec4d.svg";